import React from "react";

function FlowchartIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="#86886C"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M16 18a3 3 0 106 0 3 3 0 00-6 0zM9 6a3 3 0 106 0 3 3 0 00-6 0zM2 18a3 3 0 106 0 3 3 0 00-6 0zM10.49 8.59l-3.98 6.83M17.49 15.41l-3.98-6.82"
      ></path>
    </svg>
  );
}

export default FlowchartIcon;
